// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1y_GT","name":"ConsentHeader_name__2Vbp6","birthday":"ConsentHeader_birthday__3qM3-","skeleton":"ConsentHeader_skeleton__83B0L"};